// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"523":"a368a03e","584":"3145ba13","683":"1e03361e","958":"574c6813"}[chunkId] + ".chunk.css";
};